/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import OrderQueryResult from './OrderQueryResult';

/**
 * The ShopOutputOrders model module.
 * @module model/ShopOutputOrders
 * @version 1.0
 */
class ShopOutputOrders {
    /**
     * Constructs a new <code>ShopOutputOrders</code>.
     * @alias module:model/ShopOutputOrders
     */
    constructor() { 
        
        ShopOutputOrders.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ShopOutputOrders</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ShopOutputOrders} obj Optional instance to populate.
     * @return {module:model/ShopOutputOrders} The populated <code>ShopOutputOrders</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ShopOutputOrders();

            if (data.hasOwnProperty('orders')) {
                obj['orders'] = ApiClient.convertToType(data['orders'], [OrderQueryResult]);
            }
        }
        return obj;
    }


}

/**
 * @member {Array.<module:model/OrderQueryResult>} orders
 */
ShopOutputOrders.prototype['orders'] = undefined;






export default ShopOutputOrders;

